/**
 * Collision-resistant, sortable-ish identifier.
 * Prefers `crypto.randomUUID` and degrades gracefully in older browsers.
 */
export function createId(prefix?: string): string {
  const raw =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return prefix ? `${prefix}_${raw}` : raw;
}

export function nowISO(): string {
  return new Date().toISOString();
}
